import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type LivePhotoRequest = {
  clientId?: string | null;
  data: string;
  performLivenessCheck?: boolean;
};

export type LivePhoto = {
  id: string;
  clientId: string;
  downloadLink: string;
  contentType: string;
  performLivenessCheck?: boolean;
  size: string;
  createdAt: string;
  updateAt: string;
};

export class LivePhotos extends Resource<LivePhotoRequest> {
  constructor(axiosInstance: AxiosInstance) {
    super("livePhotos", axiosInstance);
  }

  public async upload(
    clientId: string,
    livePhotoRequest: LivePhotoRequest
  ): Promise<LivePhoto> {
    return this.request({
      method: Method.POST,
      body: { clientId, ...livePhotoRequest }
    });
  }

  public async get(id: string): Promise<LivePhoto> {
    return this.request({ method: Method.GET, path: id });
  }

  public async download(id: string): Promise<LivePhoto> {
    return super.download(`${id}/download`);
  }

  public async redact(id: string): Promise<void> {
    return this.request({ method: Method.POST, path: `${id}/redact` });
  }

  public async delete(id: string): Promise<void> {
    await this.request({ method: Method.DELETE, path: id });
  }

  public async list(
    clientId: string,
    {
      page,
      pageSize
    }: {
      page?: number;
      pageSize?: number;
    } = {}
  ): Promise<LivePhoto[]> {
    const { items: livePhotos } = await this.request({
      method: Method.GET,
      query: { clientId, page, pageSize }
    });

    return livePhotos;
  }
}
